
export {createSenmonkaQuestionsBlock};
import {formatDate} from '../formatDate';

function createSenmonkaQuestionsBlock(data, options, viewer) {
  if (data.length > 0) {
    data.forEach($row => {
      const $div_senmonka = document.createElement('div');
      $div_senmonka.classList.add('col-xs-12','col-md-6');
      {
        const $a = document.createElement('a');
        $a.href = options.senmonka_url + '/questions/view/' + $row.id;
        {
          const $div = document.createElement('div');
          $div.classList.add('box-top','row');
          {
            const $div2 = document.createElement('div');
            $div2.classList.add('col-xs-2');
            {
              const $img = document.createElement('img');
              $img.classList.add('is-rounded','mb5', 'is-w100');
              $img.src = $row.member_profile.portrait_path_full;
              $img.alt = $row.member_profile.nickname;
              $img.loading = 'lazy';
              $div2.appendChild($img);
            }
            $div.appendChild($div2);

            const $div3 = document.createElement('div');
            $div3.classList.add('col-xs-5','text-elps');
            {
              const $span = document.createElement('span');
              $span.textContent = $row.member_profile.nickname;
              $div3.appendChild($span);

              const $br = document.createElement('br');
              $div3.appendChild($br);

              const $span2 = document.createElement('span');
              $span2.classList.add('babysymbol','babysymbol-maternity','fz-i','c-pink','mr5','mb5');
              $div3.appendChild($span2);

              const $span3 = document.createElement('span');
              $span3.textContent = $row.state_at_posted[0].state;
              $div3.appendChild($span3);
            }
            $div.appendChild($div3);

            const $div4 = document.createElement('div');
            $div4.classList.add('col-xs-5','text-right');
            {
              const $span4 = document.createElement('span');
              $span4.classList.add('c-pink');
              $span4.textContent = formatDate(new Date($row.posted));
              $div4.appendChild($span4);

              const $br2 = document.createElement('br');
              $div4.appendChild($br2);

              const $span5 = document.createElement('span');
              $span5.classList.add('babysymbol','babysymbol-view','fz-i','mr5');
              $div4.appendChild($span5);

              const $span6 = document.createElement('span');
              $span6.textContent = $row.page_views_count;
              $div4.appendChild($span6);

            }
            $div.appendChild($div4);
          }
          $a.appendChild($div);

          const $div5 = document.createElement('div');
          $div5.classList.add('box-middle');
          {
            const $p = document.createElement('p');
            $p.classList.add('fw-bold');
            $p.textContent = $row.title;
            $div5.appendChild($p);

            const $p2 = document.createElement('p');
            $p2.classList.add('mb10');
            $p2.textContent = $row.body;
            $div5.appendChild($p2);

          }
          $a.appendChild($div5);

          const $div6 = document.createElement('div');
          $div6.classList.add('box-bottom','row','between-xs');
          {
            const $div7 = document.createElement('div');
            $div7.classList.add('col-xs-6');
            {
              const $div8 = document.createElement('div');
              $div8.classList.add('label-answer');
              if($row.status_label === '回答済み'){
                $div8.textContent = '専門家回答あり';
              }else{
                $div8.textContent = '専門家回答待ち';
              }
              $div7.appendChild($div8);
            }
            $div6.appendChild($div7);

            const $div9 = document.createElement('div');
            $div9.classList.add('col-xs-6','text-right');
            {
              const $span7 = document.createElement('span');
              $span7.classList.add('label-round','is-palepink');
              $span7.textContent = $row.topic_name;
              $div9.appendChild($span7);
            }

            $div6.appendChild($div9);

          }
          $a.appendChild($div6);
        }
        $div_senmonka.appendChild($a);
      }
      viewer.appendChild($div_senmonka);
    });

    return true;
  }
}

